import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '@/assets/img/logo-lh.png';
const _hoisted_1 = {
  class: "index-page"
};
const _hoisted_2 = {
  class: "menu-box"
};
const _hoisted_3 = {
  class: "menu-item"
};
const _hoisted_4 = {
  class: "menu-item"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  class: "navs animate__animated animate__backInDown"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "mt-[5px]"
};
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import FooterBar from "@/components/FooterBar.vue";
import ThemeChange from "@/components/ThemeChange.vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { checkSession, getLicenseInfo, getSystemInfo } from "@/store/cache";
import { isMobile } from "@/utils/libs";
import { useSharedStore } from "@/store/sharedata";
import { removeUserToken } from "@/store/session";
import { useUserStoreWithOut } from "@/store/modules/user";
export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {
    const userStore = useUserStoreWithOut();
    // 定义主题状态，初始值从 localStorage 获取
    const store = useSharedStore();
    const isDarkMode = computed(() => store.theme !== "light");
    const route = useRoute();
    const router = useRouter();
    if (isMobile()) {
      router.push("/mobile/index");
    }
    const title = ref("");
    const logo = ref("");
    const slogan = ref("");
    const license = ref({
      de_copy: true
    });
    const isLogin = ref(false);
    const docsURL = ref(process.env.VUE_APP_DOCS_URL);
    const gitURL = ref(process.env.VUE_APP_GIT_URL);
    const navs = ref([]);
    const iconMap = ref({
      "/chat": "icon-chat",
      "/mj": "icon-mj",
      "/sd": "icon-sd",
      "/dalle": "icon-dalle",
      "/images-wall": "icon-image",
      "/suno": "icon-suno",
      "/xmind": "icon-xmind",
      "/apps": "icon-app",
      "/member": "icon-vip-user",
      "/invite": "icon-share",
      "/luma": "icon-luma"
    });
    const displayedChars = ref([]);
    const initAnimation = ref("");
    let timer; // 定时器句柄
    // 初始化间隔时间和随机时间数组
    const interTime = ref(50);
    const interArr = [90, 100, 70, 88, 80, 110, 85, 400, 90, 99];
    function renderUrl(menu) {
      return '/aip/' + menu.path;
    }
    function goMenuRoute(menu) {
      router.push(renderUrl(menu)).then(() => {
        console.log('Navigation complete!');
      }).catch(err => {
        console.error('Navigation failed:', err);
      });
    }
    onMounted(() => {
      getSystemInfo().then(res => {
        title.value = res.data.title;
        logo.value = res.data.logo;
        slogan.value = res.data.slogan;
        // if (timer) clearInterval(timer); // 清除定时器
        // timer = setInterval(setContent, interTime.value);
      }).catch(e => {
        ElMessage.error("获取系统配置失败：" + e.message);
      });
      getLicenseInfo().then(res => {
        license.value = res.data;
      }).catch(e => {
        license.value = {
          de_copy: false
        };
        ElMessage.error("获取 License 配置失败：" + e.message);
      });
      httpGet("/system/auth/getMyMenuList").then(res => {
        navs.value = res;
      }).catch(e => {
        ElMessage.error("获取导航菜单失败：" + e.message);
      });
      checkSession().then(() => {
        isLogin.value = true;
        // 检查路由参数中是否有重定向路径
        if (route.query.redirect) {
          const redirectPath = route.query.redirect;
          // 延迟跳转
          setTimeout(() => {
            router.push(redirectPath);
          }, 300);
        }
      }).catch(() => {});
    });
    // 打字机内容逐字符显示
    const setContent = () => {
      if (initAnimation.value.length >= slogan.value.length) {
        // 文本已全部输出
        initAnimation.value = "";
        displayedChars.value = [];
        if (timer) clearInterval(timer);
        timer = setInterval(setContent, interTime.value);
        return;
      } else {
        const nextChar = slogan.value.charAt(initAnimation.value.length);
        initAnimation.value += slogan.value.charAt(initAnimation.value.length); // 逐字符追加
        displayedChars.value.push(nextChar);
        interTime.value = interArr[Math.floor(Math.random() * interArr.length)]; // 设置随机间隔
        if (timer) clearInterval(timer);
        timer = setInterval(setContent, interTime.value);
      }
    };
    // 计算彩虹色
    const rainbowColor = index => {
      const hue = index * 40 % 360; // 每个字符间隔40度，形成彩虹色
      return `hsl(${hue}, 90%, 50%)`; // 色调(hue)，饱和度(70%)，亮度(50%)
    };
    const logout = function () {
      httpPost("/system/auth/logout").then(async () => {
        removeUserToken();
        await userStore.loginOut();
        router.push("/login");
      }).catch(() => {
        ElMessage.error("注销失败！");
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_space = _resolveComponent("el-space");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ThemeChange), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_menu, {
        mode: "horizontal",
        ellipsis: false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
          src: _imports_0,
          class: _normalizeClass(["logo", {
            'dark-mode-logo': isDarkMode.value
          }]),
          alt: "LEHE-AI"
        }, null, 2)]), _createElementVNode("div", _hoisted_4, [!isLogin.value ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/login')),
          class: "btn-go animate__animated animate__pulse animate__infinite",
          round: ""
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("登录/注册")])),
          _: 1
        })])) : _createCommentVNode("", true), isLogin.value ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: logout,
          style: {
            "color": "#fff"
          },
          class: "btn-go animate__animated animate__pulse animate__infinite",
          round: ""
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("退出登录")])),
          _: 1
        })])) : _createCommentVNode("", true)])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_space, {
        wrap: "",
        size: 14
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navs.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.url,
            class: "nav-item-box",
            onClick: $event => goMenuRoute(item)
          }, [_createVNode(_component_Icon, {
            icon: item.icon,
            class: "iconfont mr-5px",
            size: 48
          }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1)], 8, _hoisted_9);
        }), 128))]),
        _: 1
      })])]), _createVNode(FooterBar)]);
    };
  }
});